import { c as _c } from "react/compiler-runtime";
import { clsx } from 'clsx';
import type { CardTagProps } from './ListingCard.types';
import styles from './ListingCardTag.module.css';
const ListingCardTag = t0 => {
  const $ = _c(10);
  const {
    icon,
    children,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = clsx(styles.tag, className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== icon) {
    t2 = icon != null && <span className={styles.icon} aria-hidden="true">{icon}</span>;
    $[2] = icon;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== children) {
    t3 = <span>{children}</span>;
    $[4] = children;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t1 || $[7] !== t2 || $[8] !== t3) {
    t4 = <span className={t1} data-test-id="CardTag">{t2}{t3}</span>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
export { ListingCardTag };